import {
  MACHINES_IN_SERVICE_PERCENTAGE_GET,
  TOP_PRODUCTS_IN_SERVICE_GET,
  DEMANDED_PRODUCTS_GET,
  PERCENTAGE_FILTER_ASC,
  PERCENTAGE_FILTER_DESC,
  DEMAND_FILTER_ASC,
  DEMAND_FILTER_DESC
} from "./mutation-types";

export default {
  [MACHINES_IN_SERVICE_PERCENTAGE_GET](state, data) {
    state.productsInService = data.inServiceTotal;
    state.productsInServicePercentage = parseFloat(
      ((data.inServiceTotal * 100) / data.totalProducts).toFixed(1)
    );
    state.chartOptions.series["0"].data["0"].y =
      state.productsInServicePercentage;
    state.chartOptions.series[
      "0"
    ].dataLabels.format = `<div style="text-align:center; margin-top:-45px">
                  <span style="font-family: 'Oswald', sans-serif !important; font-size:1.25rem !important; font-weight:400; color:#FF4141">{y}%</span>
                  <br/><span style="font-size:14px;color:silver">${
                    state.productsInService
                  } ${
      state.productsInService == 1 ? "Equipo" : "Equipos"
    }</span></div>`;
    if (state.productsInServicePercentage < 11) {
      state.chartOptions.series[0].data[0].color = "#009d4f";
      state.chartOptions.series[
        "0"
      ].dataLabels.format = `<div style="text-align:center; margin-top:-45px">
                      <span style="font-family: 'Oswald', sans-serif !important; font-size:1.25rem !important; font-weight:400; color:#009d4f">{y}%</span>
                      <br/><span style="font-size:14px;color:silver">${
                        state.productsInService
                      } ${
        state.productsInService == 1 ? "Equipo" : "Equipos"
      }</span></div>`;
    }
  },
  [TOP_PRODUCTS_IN_SERVICE_GET](state, data) {
    data.onSnapshot(async products => {
      state.productsOnServiceTop = [];
      await products.forEach(product => {
        if (product.data().quantity) {
          state.productsOnServiceTop.push({
            model: product.data().model,
            percentage: parseFloat(
              (
                (product.data().inService * 100) /
                product.data().quantity
              ).toFixed(1)
            ),
            eq: product.data().quantity
          });
        }
      });
      state.productsOnServiceTop.sort(function(a, b) {
        if (a.percentage < b.percentage) {
          return 1;
        }
        if (a.percentage > b.percentage) {
          return -1;
        }
        return 0;
      });
    });
  },
  [DEMANDED_PRODUCTS_GET](state, data) {
    state.productsDemanded = [];
    data.onSnapshot(async products => {
      products.forEach(product => {
        if (product.data().quantity) {
          state.productsDemanded.push({
            model: product.data().model,
            eq: product.data().quantity,
            demanded: product.data().orderCount
          });
        }
      });
    });
  },
  [PERCENTAGE_FILTER_ASC](state) {
    state.productsOnServiceTop.sort(function(a, b) {
      if (a.percentage > b.percentage) {
        return 1;
      }
      if (a.percentage < b.percentage) {
        return -1;
      }
      return 0;
    });
  },
  [PERCENTAGE_FILTER_DESC](state) {
    state.productsOnServiceTop.sort(function(a, b) {
      if (a.percentage < b.percentage) {
        return 1;
      }
      if (a.percentage > b.percentage) {
        return -1;
      }
      return 0;
    });
  },
  [DEMAND_FILTER_ASC](state) {
    state.productsDemanded.sort(function(a, b) {
      if (a.demanded > b.demanded) {
        return 1;
      }
      if (a.demanded < b.demanded) {
        return -1;
      }
      return 0;
    });
  },
  [DEMAND_FILTER_DESC](state) {
    state.productsDemanded.sort(function(a, b) {
      if (a.demanded < b.demanded) {
        return 1;
      }
      if (a.demanded > b.demanded) {
        return -1;
      }
      return 0;
    });
  }
};
